import type { Entry as UserEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCollectionHandler } from "./useCollectionHandler"
import { CollectionKey } from "src/types"

export function useUserEntriesHandler() {
  return useCollectionHandler<UserEntry>(CollectionKey.UserEntry)
}
